import {
	Box,
	Button,
	Chip,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Menu,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableRow,
} from '@mui/material';
import { FC, SyntheticEvent, useState, useRef } from 'react';
import { AmountAndCurrency } from 'ui/AmountAndCurrency';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export type TTableCellSpeedDialProps = {
	children?: React.ReactNode;
	data: { name: string; value: number | null }[];
	selectedRow: boolean;

	header?: string;
};

export const TableCellSpeedDial: FC<TTableCellSpeedDialProps> = ({
	children,
	data,
	selectedRow,
	header = '',
}) => {
	const anchorEl = useRef<HTMLDivElement>(null);
	const [open, setOpen] = useState(false);

	const speedDialTooltipOpen = (e: SyntheticEvent) => {
		e.stopPropagation();
		setOpen(true);
	};
	const speedDialTooltipClose = (e: SyntheticEvent) => {
		e.stopPropagation();
		setOpen(false);
	};

	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'end',
			}}
		>
			{children}
			{children && (
				<ExpandMoreIcon fontSize="small" sx={{ visibility: selectedRow ? 'visible' : 'hidden' }} />
			)}

			<>
				<div
					ref={anchorEl}
					onClick={speedDialTooltipOpen}
					style={{ position: 'absolute', right: '0', top: '0', width: '100%', height: '100%' }}
					className="action-speed-dial"
				/>
				<Menu
					anchorEl={anchorEl.current}
					open={open}
					onClose={speedDialTooltipClose}
					sx={{
						'& .MuiPaper-root': {
							// width: '270px',
							maxWidth: 'none',
							borderRadius: '12px',
							p: 0,
							m: 0,
						},
						'& .MuiList-root': {
							padding: 0,
							m: 0,
						},
					}}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}}
				>
					<Box>
						{!!header && (
							<DialogTitle color="primary" sx={{ p: '10px', fontSize: '1rem' }}>
								{header}
							</DialogTitle>
						)}
						<DialogContent sx={{ p: '10px' }}>
							<TableContainer>
								<Table>
									<TableBody>
										{data.map((item) => (
											<TableRow key={item.name}>
												<TableCell sx={{ padding: '2px', borderBottom: 0 }}>{item.name}:</TableCell>
												<TableCell align="right" sx={{ padding: '2px', borderBottom: 0 }}>
													{item?.value ? (
														<AmountAndCurrency amount={item.value} currency="EUR" size={0.9} />
													) : (
														'pending'
													)}
												</TableCell>
											</TableRow>
										))}
									</TableBody>
								</Table>
							</TableContainer>
						</DialogContent>
					</Box>
				</Menu>
			</>
		</Box>
	);
};
